export default function filterBySelectedBtn (initalArray,buttonStatus) {
    if(buttonStatus === "ENABLED" || buttonStatus === "PAUSED") {
        const arrayToBeReturned = initalArray.filter((campaign) => {
            return campaign.status === buttonStatus
        });
        return arrayToBeReturned
    }
    return initalArray;
}